var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "block-editor create-task" }, [
    _c(
      "div",
      { staticClass: "editor-row customize-editor-minimize" },
      [
        _c("div", { staticClass: "editor-row-title" }, [_vm._v("Title")]),
        _vm._v(" "),
        _c("TiptapEditor", {
          attrs: {
            placeholder: "Title",
            "show-attributes": true,
            "max-character-count": 500,
          },
          model: {
            value: _vm.clone.title,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "title", $$v)
            },
            expression: "clone.title",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "editor-row customize-editor" },
      [
        _c("div", { staticClass: "editor-row-title" }, [_vm._v("Description")]),
        _vm._v(" "),
        _c("TiptapEditor", {
          attrs: {
            placeholder: "Description",
            "show-attributes": true,
            "max-character-count": 2048,
          },
          model: {
            value: _vm.clone.description,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "description", $$v)
            },
            expression: "clone.description",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "editor-row" },
      [
        _c("div", { staticClass: "editor-row-title" }, [_vm._v("Priority")]),
        _vm._v(" "),
        _c("a-select", {
          staticClass: "classic-new-select",
          attrs: { placeholder: "Priority", options: _vm.priority },
          model: {
            value: _vm.clone.priority,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "priority", $$v)
            },
            expression: "clone.priority",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "editor-row" },
      [
        _c("div", { staticClass: "editor-row-title" }, [_vm._v("Workflow")]),
        _vm._v(" "),
        _c("a-select", {
          staticClass: "classic-new-select",
          attrs: { placeholder: "Workflow", options: _vm.workflows },
          model: {
            value: _vm.clone.workflowId,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "workflowId", $$v)
            },
            expression: "clone.workflowId",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "editor-row" },
      [
        _c("div", { staticClass: "editor-row-title" }, [_vm._v("Pipeline")]),
        _vm._v(" "),
        _c("a-select", {
          staticClass: "classic-new-select",
          attrs: {
            disabled: !_vm.clone.workflowId,
            placeholder: "Pipeline",
            options: _vm.pipelines,
          },
          model: {
            value: _vm.clone.pipelineStageId,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "pipelineStageId", $$v)
            },
            expression: "clone.pipelineStageId",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "editor-row" },
      [
        _c("div", { staticClass: "editor-row-title" }, [_vm._v("Owner")]),
        _vm._v(" "),
        _c("a-select", {
          staticClass: "classic-new-select",
          attrs: { placeholder: "Owner", options: _vm.users },
          model: {
            value: _vm.clone.ownerId,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "ownerId", $$v)
            },
            expression: "clone.ownerId",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "editor-row" },
      [
        _c("div", { staticClass: "editor-row-title" }, [_vm._v("Assignees")]),
        _vm._v(" "),
        _c("a-select", {
          staticClass: "classic-new-select",
          attrs: {
            placeholder: "Assignees",
            mode: "multiple",
            options: _vm.users,
          },
          model: {
            value: _vm.clone.assigneeIds,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "assigneeIds", $$v)
            },
            expression: "clone.assigneeIds",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }